export default "__VITE_ASSET__BxTLMydD__"